import Component from './LoadCurrentUser'

export default Component
